import { useState, useEffect } from "react";
import styles from "./style.module.css";
import goldLogo from "../../assets/images/gold-logo.svg";
import AuthCode from "react-auth-code-input";
import cbn from "../../assets/icons/cbn.svg";
import Modal from "../../Components/Modal";
import axios from "axios";
import Loader from "../../Components/Loader";
import Success from "../Success";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import { baseUrl } from "../../utils/baseUrl";
const NinOpenAccount = () => {
  const apiUrl = baseUrl;

  const navigate = useNavigate();
  const [accountNumber, setAccountNumber] = useState("");
  // const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberAccount, setMobileNumberAccount] = useState("");

  const [NationIdentityNumber, setIdentityNumber] = useState("");
  const [result, setResult] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);

  const [accountNumberError, setAccountNumberError] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [mobileNumberAfter, setMobileNumberAfter] = useState(false);
  const [mobileNumberErrorNin, setMobileNumberErrorNin] = useState(false);
  const [ninError, setninError] = useState(false);
  const [firstNameError, setFirstNameError] = useState(false);
  const [middleNameError, setMiddleNameError] = useState(false);
  const [lastNameError, setlastNameError] = useState(false);
  const [dobError, setdobError] = useState(false);
  const [genderError, setgenderError] = useState(false);
  const [ninLinkingFailure, setNinLinkFailure] = useState(false);

  const [xfirstName, setxfirstname] = useState("");
  const [xlastName, setxlastname] = useState("");
  const [xmiddleName, setxmiddlename] = useState("");
  const [xaccountNumber, setxaccountNumber] = useState("");
  const [xphoneNummber, setxphoneNummber] = useState("");
  const [xgender, setxgender] = useState("");
  const [xdob, setxdob] = useState("");
  const [xnin, setxnin] = useState("");
  const [xcif, setxcif] = useState("");
  const [xbvn, setxbvn] = useState("");
  const [xemail, setXEmail] = useState("");
  const [resendOtpActive, setResendOtpActive] = useState(false);

  const successTrue = () => {
    setSuccessModal(false);
    setAccountNumber("");
    setIdentityNumber("");
    // setMobileNumber("");
    setShowOtp(false);
  };

  useEffect(() => {
    setTimeout(function () {
      setResendOtpActive(true);
      // }, 300000); // 60 seconds in milliseconds
    }); // 60 seconds in milliseconds
  }, []);

  const validateOtp = () => {
    if (result.length === 4) {
      setLoading(true);
      const ninVerifivcationPayload = {
        firstName: xfirstName,

        lastName: xlastName,
        middleName: xmiddleName,

        accountNumber: accountNumber,
        BvnPhoneNumber: xphoneNummber,
        AccountPhoneNumber: xaccountNumber,
        gender: xgender,
        dateOfBirth: xdob,
        nin: xnin,
        ciF_NO: xcif,
        otp: result,
        bvn: xbvn,
      };

      // console.log(ninVerifivcationPayload)

      axios
        .post(
          apiUrl + "/ExistingCustomerNINVerification/VerifyExistingCustomerNIN",
          ninVerifivcationPayload
        )
        .then((newResponse) => {
          console.log(newResponse, "new response");

          if (
            newResponse.data.responseCode === 9 ||
            newResponse.data.responseCode === 400
          ) {
            setShowModal(true);
            setninError(true);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setFirstNameError(false);
            setShowOtp(false);
            setResult("");
            setdobError(false);
            setgenderError(false);

            setlastNameError(false);
            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setNinLinkFailure(false);
          } else if (newResponse.data.responseCode === 10) {
            setFirstNameError(true);
            setShowModal(true);
            setdobError(false);
            setgenderError(false);

            setninError(false);
            setlastNameError(false);
            setShowOtp(false);
            setResult("");
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setNinLinkFailure(false);
          } else if (newResponse.data.responseCode === 11) {
            setMiddleNameError(true);
            setShowModal(true);
            setdobError(false);
            setgenderError(false);
            setShowOtp(false);
            setResult("");
            setninError(false);
            setlastNameError(false);
            setFirstNameError(false);

            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setNinLinkFailure(false);
          } else if (newResponse.data.responseCode === 12) {
            setlastNameError(true);
            setShowModal(true);
            setdobError(false);
            setgenderError(false);
            setShowOtp(false);
            setResult("");
            setninError(false);

            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setNinLinkFailure(false);
          } else if (newResponse.data.responseCode === 13) {
            setShowOtp(false);
            setResult("");
            setninError(false);
            setlastNameError(false);
            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberAfter(false);
            setMobileNumberErrorNin(true);
            setNinLinkFailure(false);
            setShowModal(true);
          } else if (newResponse.data.responseCode === 14) {
            setdobError(false);
            setShowOtp(false);
            setResult("");
            setgenderError(true);
            setninError(false);
            setlastNameError(false);
            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setNinLinkFailure(false);
            setShowModal(true);
          } else if (newResponse.data.responseCode === 15) {
            setdobError(true);
            setgenderError(false);
            setninError(false);
            setlastNameError(false);
            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setShowModal(true);
            setShowOtp(false);
            setNinLinkFailure(false);
            setResult("");
          } else if (newResponse.data.responseCode === 8) {
            toast.error("Expired OTP. Please Try Again");
            setShowOtp(true);
            setResult("");
          } else if (newResponse.data.responseCode === 7) {
            toast.error("Wrong OTP. Please Try Again");
            setShowOtp(true);
            setResult("");
          } else if (newResponse.data.responseCode === 16) {
            toast.error("Failed to update customer information");
          } else if (newResponse.data.success) {
            setSuccessModal(true);
          } else {
            setNinLinkFailure(true);
            setdobError(false);
            setgenderError(false);
            setninError(false);
            setlastNameError(false);
            setFirstNameError(false);
            setMiddleNameError(false);
            setMobileNumberError(false);
            setAccountNumberError(false);
            setMobileNumberError(false);
            setShowModal(true);
            setShowOtp(false);
            setResult("");
          }

          setLoading(false);
        })
        .catch((err) => {
          //   console.log(err)
          setLoading(false);
        });
    } else {
      toast.error("OTP field cannot be empty");
    }
  };
  //     else {
  //        toast.errorToast("wrong otp")
  //     }
  // }

  const validateNin = () => {
    if (
      accountNumber.toString().length > 10 ||
      accountNumber.toString().length < 10
    ) {
      toast.error("Please Input a Valid Account Number");
    }
    //  else if (mobileNumber.toString().length > 11 || mobileNumber.toString().length < 11){
    //     toast.error("Please Input a Valid Phone Number")
    //  }
    else if (
      NationIdentityNumber.toString().length > 11 ||
      NationIdentityNumber.toString().length < 11
    ) {
      toast.error("Please Input a Valid National Identification Number");
    } else {
      const ninpayLoad = {
        accountNumber: accountNumber.toString(),

        nin: NationIdentityNumber.toString(),
      };
      setLoading(true);

      axios
        .post(
          apiUrl + "/ExistingCustomerNINVerification/AccountDetails",
          ninpayLoad
        )
        .then((response) => {
          console.log(response);
          if (response.data.message.length < 1 && response.data.success) {
            setShowOtp(true);

            setxfirstname(response.data.firstName);
            setxlastname(response.data.lastName);
            setxmiddlename(response.data.middleName);
            setxaccountNumber(response.data.accountPhoneNumber);
            setxgender(response.data.gender);
            setMobileNumberAccount(response.data?.accountPhoneNumber);
            setxdob(response.data.dateOfBirth);
            setxphoneNummber(response.data.bvnPhoneNumber);
            setxnin(response.data.nin);
            setxcif(response.data.ciF_NO);
            setxbvn(response.data.bvn);
            setXEmail(response.data.email);
          } else if (
            response.data.message ===
            "The BVN PhoneNumber does not match with your registered Account PhoneNumber"
          ) {
            setninError(false);
            setMobileNumberError(true);
            setAccountNumberError(false);
            setShowModal(true);
          } else if (
            response.data.message ===
            "The provided PhoneNumber does not match with your registered Account PhoneNumber"
          ) {
            setMobileNumberAfter(true);
            setninError(false);

            setAccountNumberError(false);
            setShowModal(true);
          } else if (
            response.data.message ===
            "Could not retrieve bvn details due to downtime, please try again"
          ) {
            toast.error(
              "Could not retrieve bvn details due to downtime, please try again"
            );
          } else if (
            response.data.message === "NIN is already linked to account"
          ) {
            toast.error("Your NIN is already linked to account");
          } else {
            setShowModal(true);
            setAccountNumberError(true);
            setMobileNumberError(false);
            setninError(false);
          }

          setLoading(false);
        })
        .catch((err) => {
          // console.log(err)
          setShowModal(true);
          setLoading(false);
        });
    }
  };

  const handleOnChange = (res: string) => {
    setResult(res);
  };

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    e.currentTarget.blur();
  };

  const resendotp = () => {
    setLoading(true);
    const resendotpPaylod = {
      emailAddress: xemail,
      phoneNumber: mobileNumberAccount,
      customerName: `${xfirstName} ${xmiddleName} ${xlastName}`,
      bvn: xbvn,
    };

    axios
      .post(
        apiUrl + "/ExistingCustomerNINVerification/ResendOTP",
        resendotpPaylod
      )
      .then((response) => {
        if (response) {
          toast.success("OTP sent successfully");
        }
        // console.log(response)
        setLoading(false);
      })
      .catch((err) => {
        // console.log(err)
        toast.error("something went wrong, please try again");
        setLoading(false);
      });
  };
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {loading && <Loader />}
      <div className={styles.openAccountConatiner}>
        <div className={styles.coverContainer}>
          <div className={styles.firstContainer}>
            <img src={goldLogo} alt="gold-logo" className={styles.logo} />
            <h6>
              Licensed by Central Bank of Nigeria{" "}
              <img src={cbn} alt="cbn-icon" />
            </h6>
          </div>
          <div className={styles.secondContainer}>
            <p>NIN Collection Portal</p>
            <h6>
              Licensed by Central Bank of Nigeria{" "}
              <img src={cbn} alt="cbn-icon" />
            </h6>
          </div>
        </div>
        <div className={styles.container}>
          {successModal ? (
            <Success successTrue={successTrue} />
          ) : (
            <>
              <h3>Update your Information</h3>
              <h4>Enter your information and click proceed</h4>
              <div className={styles.formGroup}>
                <p>Account Number</p>
                <input
                  type="number"
                  value={accountNumber}
                  onChange={(e) => setAccountNumber(e.target.value)}
                  placeholder="Enter Account Number"
                  //@ts-ignore
                  //@ts-nocheck
                  className={styles.numberInput}
                  onWheel={handleWheel}
                />
              </div>
              {/* <div className={styles.formGroup}>
                    <p>Enter the Phone number linked to your NIN</p>
                    <input 
                     type="number"
                    value={mobileNumber} 
                    onChange={(e) => setMobileNumber(e.target.value)}
                    placeholder="Enter the Phone number"
                    className={styles.numberInput}
                 
                    onWheel={handleWheel}
                    />
                </div> */}
              <div className={styles.formGroup}>
                <p>National Identity Number</p>
                <input
                  type="number"
                  value={NationIdentityNumber}
                  onChange={(e) => setIdentityNumber(e.target.value)}
                  placeholder="Enter NIN"
                  className={styles.numberInput}
                  onWheel={handleWheel}
                />
              </div>
              {showOtp && (
                <div className={styles.otpContainer}>
                  {resendOtpActive ? (
                    <p className={styles.resendotp} onClick={resendotp}>
                      Resend OTP
                    </p>
                  ) : (
                    <p className={styles.resendotpintive}>Resend OTP</p>
                  )}

                  <div className={styles.otpHeader}>
                    <p>OTP Verification</p>
                  </div>
                  <p className={styles.enterOtpText}>Enter OTP</p>
                  <div className={styles.otpSubContainer}>
                    <AuthCode
                      inputClassName={styles.textCenter}
                      placeholder="*"
                      length={4}
                      allowedCharacters="numeric"
                      onChange={handleOnChange}
                    />
                  </div>
                </div>
              )}

              <div className={styles.flexButton}>
                <button
                  onClick={() => {
                    setShowOtp(false);
                    navigate("/");
                    setAccountNumber("");
                    setIdentityNumber("");
                  }}
                >
                  Cancel
                </button>
                {accountNumber.length > 1 && NationIdentityNumber.length > 1 ? (
                  <>
                    {showOtp ? (
                      <button className={styles.active} onClick={validateOtp}>
                        Proceed
                      </button>
                    ) : (
                      <button className={styles.active} onClick={validateNin}>
                        Proceed
                      </button>
                    )}
                  </>
                ) : (
                  <button className={styles.inactive} disabled>
                    Proceed
                  </button>
                )}
              </div>
            </>
          )}
        </div>
        <Modal
          openModal={showModal && ninError}
          closeModal={() => setShowModal(false)}
          header="An error occurred during NIN verification"
          paragraph="Please visit any branch of the BVN enrolment bank care or visit the NIMC office to rectify NIN Details"
        />
        <Modal
          openModal={showModal && mobileNumberError}
          closeModal={() => setShowModal(false)}
          header="Mobile number MissMatch"
          paragraph="Your mobile number does not match either your NIN or BVN. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details. "
        />
        <Modal
          openModal={showModal && mobileNumberErrorNin}
          closeModal={() => setShowModal(false)}
          header="Mobile number MissMatch."
          paragraph="Your mobile number does not match either your NIN or BVN. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
        />
        <Modal
          openModal={showModal && mobileNumberAfter}
          closeModal={() => setShowModal(false)}
          header="Phone Number does not match"
          paragraph="The mobile number you provided doesn't match the one linked to your Account. Please visit any of our branch to update your phone number details."
        />
        <Modal
          openModal={showModal && dobError}
          closeModal={() => setShowModal(false)}
          header="Date of Birth does not match"
          paragraph="Please note that the date of birth in your BVN and NIN records does not match. Please visit any branch of your BVN enrollment bank or the NIMC office to update your NIN details. "
        />
        <Modal
          openModal={showModal && genderError}
          closeModal={() => setShowModal(false)}
          header="Gender Mismatch"
          paragraph="The gender details on your BVN and NIN do not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details. "
        />
        <Modal
          openModal={showModal && accountNumberError}
          closeModal={() => setShowModal(false)}
          header="Invalid account number"
          paragraph="The account number you entered does not exist. Please double-check and try again"
        />
        <Modal
          openModal={showModal && firstNameError}
          closeModal={() => setShowModal(false)}
          header="First Name does not match"
          paragraph="The first name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details.  "
        />
        <Modal
          openModal={showModal && middleNameError}
          closeModal={() => setShowModal(false)}
          header="Middle name mismatch"
          paragraph="The Middle name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details."
        />
        <Modal
          openModal={showModal && lastNameError}
          closeModal={() => setShowModal(false)}
          header="Last name does not match"
          paragraph="The Last name on your BVN and NIN does not match. Kindly visit any branch of your BVN enrollment bank or the NIMC office to rectify your NIN details. "
        />

        <Modal
          openModal={showModal && ninLinkingFailure}
          closeModal={() => setShowModal(false)}
          header="NIN linking failed"
          paragraph="Your attempt to link your NIN was unsuccessful. Please try again later."
        />
      </div>
    </>
  );
};

export default NinOpenAccount;
